import React from 'react';
import { WidgetsProvider } from '@sitecore-search/react';
import SearchPreviewWidget from './components/SearchPreviewWidget';

function SearchPreview({
  customerKey,
  apiKey,
  inputPlaceholder,
  viewAll,
  submitLabel,
  urlViewAll,
  countryContext,
  languageContext,
  rfkId
}) {
  return (
    <WidgetsProvider env="prod" customerKey={customerKey} apiKey={apiKey}>
      <form action={urlViewAll} className="header-search__input">
        <svg viewBox="0 0 26 27" className="header-search__input-icon">
          <use xlinkHref="#search" />
        </svg>
        <SearchPreviewWidget
          rfkId={rfkId}
          inputPlaceholder={inputPlaceholder}
          viewAll={viewAll}
          countryContext={countryContext}
          languageContext={languageContext}
          urlViewAll={urlViewAll}
        />
        <button
          type="submit"
          className="btn btn--primary btn--outline btn--small"
        >
          {submitLabel}
        </button>
      </form>
    </WidgetsProvider>
  );
}

export default SearchPreview;
